import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import InputBase from '@material-ui/core/InputBase';
import Settings from '@material-ui/icons/Settings';
import CheckCircle from '@material-ui/icons/CheckCircle';
import NoteAdd from '@material-ui/icons/NoteAdd';
import Cancel from '@material-ui/icons/Cancel';

import { makeStyles } from '@material-ui/core/styles'


export default function SDoCDetailCard({
	runningNo,
	sDoCNo
}) {
	return (

		<Card className={`border-t-4 border-card_top_border mb-5`}>
			<Grid className="flex flex-col justify-center items-start px-5 mb-5">
				{/* Header */}
				<Grid className="flex flex-row mt-4 mb-2">
					<Grid className="font-bold text-sm text-card_header_color">
						รายละเอียดแบบรับรองตนเอง
					</Grid>
				</Grid>
				<Grid className="mt-3 mb-1 w-full">
					<Divider />
				</Grid>
				<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
					<Grid className="flex flex-row">
						<Grid>เลขที่คำขอ</Grid>
					</Grid>
					<Grid
						className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
						<InputBase
							className="w-full"
							name="runningNo pointer-events-none"
							readOnly
							disabled
							value={runningNo}
						/>
					</Grid>
					<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
						<Grid className="flex flex-row">
							<Grid>SDoC NO.</Grid>
						</Grid>
						<Grid
							className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
							<InputBase
								className="w-full"
								name="sDoCNo"
								readOnly
								disabled
								value={sDoCNo}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Card>
	)
}
